import React, { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { colorGrupo } from "./GrupoCard";

function FitBounds({ puntos }) {
  const map = useMap();
  useEffect(() => {
    if (!puntos.length) return;
    const lats = puntos.map((p) => p.lat), lons = puntos.map((p) => p.lon);
    map.fitBounds([[Math.min(...lats), Math.min(...lons)], [Math.max(...lats), Math.max(...lons)]], { padding: [30, 30], maxZoom: 14 });
  }, [puntos.length]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

/** Mapa de la propuesta: un color por ruta; excluidas en gris apagado; salida en blanco. */
export default function MapaPropuesta({ grupos, excluidas = [], inicio }) {
  const puntos = [];
  grupos.forEach((g, i) => g.paradas.forEach((p) => { if (p.lat != null && p.lon != null) puntos.push({ ...p, _g: g, _color: colorGrupo(i).hex }); }));
  const exc = excluidas.filter((p) => p.lat != null && p.lon != null);
  if (!puntos.length && !exc.length) return null;
  const center = puntos[0] || exc[0];
  return (
    <div className="rounded-xl overflow-hidden border border-zinc-800 relative" data-testid="mapa-propuesta">
      <div className="absolute z-[500] top-2 left-2 flex flex-wrap gap-1.5 max-w-[70%]">
        {grupos.map((g, i) => (
          <span key={g.id} className="text-[10px] px-2 py-0.5 rounded-full bg-zinc-950/85 border border-zinc-700 text-zinc-100 inline-flex items-center gap-1" data-testid={`leyenda-${g.id}`}>
            <span className="w-2.5 h-2.5 rounded-full inline-block" style={{ background: colorGrupo(i).hex }} />{g.id} · {g.ciudad_principal || "—"} · {g.n_paradas}
          </span>
        ))}
        {exc.length > 0 && <span className="text-[10px] px-2 py-0.5 rounded-full bg-zinc-950/85 border border-zinc-700 text-zinc-400 inline-flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-full inline-block bg-zinc-500" />Excluidas · {exc.length}</span>}
      </div>
      <MapContainer center={[center.lat, center.lon]} zoom={11} style={{ height: 380, width: "100%" }} scrollWheelZoom={false} className="z-0">
        <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <FitBounds puntos={[...puntos, ...exc]} />
        {inicio && <CircleMarker center={[inicio.lat, inicio.lon]} radius={7} pathOptions={{ color: "#fff", fillColor: "#fff", fillOpacity: 0.9 }}><Popup>Punto de salida</Popup></CircleMarker>}
        {exc.map((p) => (
          <CircleMarker key={`x-${p.linea_id}`} center={[p.lat, p.lon]} radius={5} pathOptions={{ color: "#71717a", fillColor: "#3f3f46", fillOpacity: 0.7, dashArray: "2 2" }}>
            <Popup><div className="text-xs"><b>{p.espacio_nombre}</b><br />{p.direccion}<br />{p.peticion_codigo}{p.marca ? ` · ${p.marca}` : ""}<br /><i>Excluida · {p.motivo}</i></div></Popup>
          </CircleMarker>
        ))}
        {puntos.map((p) => (
          <CircleMarker key={p.linea_id} center={[p.lat, p.lon]} radius={p.fijada ? 9 : 7}
            pathOptions={{ color: p.fijada ? "#fff" : p._color, weight: p.fijada ? 3 : 2, fillColor: p._color, fillOpacity: 0.85 }}
            eventHandlers={{}} data-testid={`marker-${p.linea_id}`}>
            <Popup>
              <div className="text-xs space-y-0.5">
                <b>{p.espacio_nombre}</b>{p.fijada && " 🔒"}<br />{p.direccion}{p.ciudad ? `, ${p.ciudad}` : ""}<br />
                {p.peticion_codigo}{p.marca ? ` · ${p.marca}` : ""}{p.referencia_cliente ? ` · Ref. ${p.referencia_cliente}` : ""}<br />
                <span style={{ color: p._color }}>● Ruta {p._g.id}</span>{p._g.montador?.nombre_visible ? ` · ${p._g.montador.nombre_visible}` : ""}
              </div>
            </Popup>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
